import React, { useEffect, useId, useRef } from 'react';
import { Button, Text } from '@fragments';
import { IconCheck, IconRefresh, IconX } from '@tabler/icons-react';
import AudioWaveform from './AudioWaveform';
import './styles.scss';

export default function AudioRecorder({ capture, t, onCancel }) {
  const statusId = useId();
  const cancelRef = useRef(null);
  useEffect(() => { cancelRef.current?.focus({ preventScroll: true }); }, []);
  const { status, error, seconds, recording, starting } = capture;
  const time = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
  const statusKey = error ? `audioRecordError_${error}` : starting ? 'audioRecordPermissionHint' : status === 'stopping' ? 'audioRecordSaving' : 'audioRecordListening';

  return <div className={`studio-recorder ${recording ? 'is-recording' : ''}`} role="group" aria-label={t('audio')} aria-describedby={statusId} onKeyDown={event => {
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); onCancel(); }
  }}>
    <div className="studio-recorder__row">
      <Button ref={cancelRef} preventLoading variant="rounded" color="overlay" size="medium" icon={<IconX />} aria-label={t('audioRecordCancel')} tooltip={t('cancel')} onClick={onCancel} />
      <AudioWaveform stream={capture.stream} />
      <Text.caption className="studio-recorder__time" contrast={8}><time>{time}</time></Text.caption>
      <Button preventLoading variant="rounded" color="inverse" size="medium" icon={error ? <IconRefresh /> : <IconCheck />} aria-label={t(error ? 'retry' : 'audioRecordFinish')} tooltip={t(error ? 'retry' : 'audioRecordFinish')} onClick={error ? capture.start : capture.stop} loading={status === 'stopping'} disabled={!error && !recording} />
    </div>
    <Text.caption id={statusId} className={`studio-recorder__status ${recording ? 'is-visually-hidden' : ''}`} contrast={7} role={error ? 'alert' : 'status'}>{t(statusKey)}</Text.caption>
  </div>;
}
